import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { authHttpInterceptorFn, AuthService, provideAuth0 } from '@auth0/auth0-angular';
import { appRoutes } from './app.routes';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes, 
      withInMemoryScrolling(
        { 
          anchorScrolling: 'enabled', 
          scrollPositionRestoration: 'enabled' 
        }
      ), 
      // withEnabledBlockingInitialNavigation()
    ),
    MessageService,
    ConfirmationService,
    DialogService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideHttpClient(
      withFetch(),
      withInterceptors([authHttpInterceptorFn])
    ),
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideAuth0(
      {
      domain: 'lexarhomes.us.auth0.com',
      clientId: 'GAw5iGOfc2EMcZOps9aGwsCrxCjtnw1k',
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: 'https://lexarhomes.api',
        scope: 'azuread'
      },
      httpInterceptor: {
        allowedList: [`${environment.landmark_API_URL}/*`],
      },
    }
  ),
  ]
};